<template>
  <v-card class="ma-3 pa-3">
    <v-card-title>
      <h2>
        {{ $t('CONTROL OBLIGACIONES FISCALES') }} - {{ year }} -
        {{ selectedQuarter === '202' ? $t('MODELO') : $t('TRIMESTRE') }}
        {{ selectedQuarter }}
      </h2>
    </v-card-title>

    <!-- Action buttons -->
    <v-layout align-center justify-start row fill-height>
      <div
        class="ml-1"
        v-if="
          !showManageModel111 &&
            (!isBeingReviewed || (isBeingReviewed && canReviewFiscalObligations))
        "
      >
        <v-btn color="primary" @click="openCreateFiscalObligationDialog()">
          <v-icon left>mdi-plus</v-icon>
          {{ $t('Añadir') }}
        </v-btn>
      </div>
      <div
        class="ml-3"
        v-if="
          !showManageModel111 &&
            (!isBeingReviewed || (isBeingReviewed && canReviewFiscalObligations))
        "
      >
        <v-btn color="light" @click="openCloneQuarterDialog()">
          <v-icon left>mdi-content-copy</v-icon>
          {{ $t('Clonar Trimestre') }}
        </v-btn>
      </div>
      <div class="ml-3">
        <v-btn color="light" @click="exportToExcel()" :disabled="exportingExcel">
          <v-icon left>mdi-file-excel-outline</v-icon>
          {{ $t('Exportar a excel') }}
          <v-progress-circular
            v-if="exportingExcel"
            class="ml-2"
            :size="20"
            indeterminate
            color="black"
          ></v-progress-circular>
        </v-btn>
      </div>
      <div
        class="ml-3"
        v-if="
          this.selectedItems.length >= 1 &&
            !showManageModel111 &&
            (!isBeingReviewed || (isBeingReviewed && canReviewFiscalObligations))
        "
      >
        <v-btn color="error" @click="showDeleteFiscalObligationForm = true">
          <v-icon left>mdi-delete</v-icon>
          {{ $t('Eliminar') }}
        </v-btn>
      </div>
      <div class="ml-1" v-if="!isBeingReviewed && canReviewFiscalObligations">
        <v-btn color="primary" :disabled="startingReview" @click="startFiscalObligationReview()">
          <v-icon left>mdi-play-circle-outline</v-icon>
          {{ $t('Comenzar revisión') }}
          <v-progress-circular
            v-if="startingReview"
            class="ml-2"
            :size="20"
            indeterminate
            color="black"
          ></v-progress-circular>
        </v-btn>
      </div>
      <div class="ml-1" v-if="isBeingReviewed && canReviewFiscalObligations">
        <v-btn color="red" :disabled="finishingReview" @click="finishFiscalObligationReview()">
          <v-icon left>mdi-stop</v-icon>
          {{ $t('Finalizar revisión') }}
          <v-progress-circular
            v-if="finishingReview"
            class="ml-2"
            :size="20"
            indeterminate
            color="black"
          ></v-progress-circular>
        </v-btn>
      </div>
      <div class="ml-1" v-if="isBeingReviewed && !canReviewFiscalObligations">
        <v-alert :value="true" color="warning" icon="priority_high" outline>
          Se están revisando las obligaciones fiscales y no es posible realizar modificaciones
        </v-alert>
      </div>
    </v-layout>
    <!-- End action buttons -->

    <!-- Filters -->
    <v-layout align-center justify-end row fill-height>
      <div class="ml-3">
        <v-autocomplete
          color="primary"
          v-model="filters.consultant_ids"
          multiple
          chips
          deletable-chips
          :items="consultantsList"
          :label="$t('Asesor/a Fiscal')"
          row
        ></v-autocomplete>
      </div>
      <div class="ml-3" v-if="showManageModel111">
        <v-select
          color="primary"
          v-model="manage111Filters.labor_consultant_ids"
          multiple
          chips
          deletable-chips
          :items="consultantsList"
          :label="$t('Asesor/a Laboral')"
          row
        ></v-select>
      </div>
      <div class="ml-3">
        <v-select
          color="primary"
          v-model="year"
          item-text="text"
          item-value="value"
          :items="years"
          row
          :label="$t('Año')"
        ></v-select>
      </div>
      <div class="ml-3">
        <v-btn-toggle v-model="quarter">
          <v-btn color="primary" value="1">
            {{ $t('T1') }}
          </v-btn>
          <v-btn color="primary" value="2">
            {{ $t('T2') }}
          </v-btn>
          <v-btn color="primary" value="3">
            {{ $t('T3') }}
          </v-btn>
          <v-btn color="primary" value="4">
            {{ $t('T4') }}
          </v-btn>
        </v-btn-toggle>
        <v-btn-toggle v-model="showManageModel111">
          <v-btn color="primary" :value="true">
            {{ $t('MOD.111-190') }}
          </v-btn>
        </v-btn-toggle>
        <v-btn-toggle v-model="quarter">
          <v-btn color="primary" value="202">
            {{ $t('MOD.202') }}
          </v-btn>
        </v-btn-toggle>
      </div>
    </v-layout>
    <v-layout row wrap class="mb-3">
      <v-flex xs12 md4>
        <v-layout row justify-end wrap style="border: dashed darkgrey 1px">
          <v-flex xs12 md6>
            <div class="ml-3">
              <v-select
                v-if="showManageModel111"
                color="primary"
                v-model="manage111Filters.selectedModelType"
                item-text="text"
                item-value="value"
                :items="[
                  { text: 'T1 - Mod. 111', value: 'mod_111_t1' },
                  { text: 'T2 - Mod. 111', value: 'mod_111_t2' },
                  { text: 'T3 - Mod. 111', value: 'mod_111_t3' },
                  { text: 'T4 - Mod. 111', value: 'mod_111_t4' },
                  { text: 'T4 - Mod. 190', value: 'mod_190_t4' },
                ]"
                :clearable="true"
                row
                :label="$t('Modelo')"
              ></v-select>
              <v-select
                v-else
                color="primary"
                v-model="filters.selectedModelType"
                item-text="text"
                item-value="value"
                :items="modelTypes"
                :clearable="true"
                row
                :label="$t('Modelo')"
              ></v-select>
            </div>
          </v-flex>
          <v-flex xs12 md6>
            <div class="ml-3 mr-3">
              <v-select
                v-if="showManageModel111"
                color="primary"
                v-model="manage111Filters.selectedModelStatus"
                item-text="text"
                item-value="value"
                :items="modelOptions"
                :clearable="true"
                row
                multiple
                :label="$t('Estado del modelo')"
              ></v-select>
              <v-select
                v-else
                color="primary"
                v-model="filters.selectedModelStatus"
                item-text="text"
                item-value="value"
                :items="modelOptions"
                :clearable="true"
                row
                multiple
                :label="$t('Estado del modelo')"
              ></v-select>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 md2 v-if="showManageModel111">
        <div class="ml-3">
          <v-checkbox v-model="manage111Filters.has_employees" label="Tiene empleados"></v-checkbox>
          <!--          <v-select-->
          <!--            color="primary"-->
          <!--            v-model="manage111Filters.has_employees"-->
          <!--            item-text="text"-->
          <!--            item-value="value"-->
          <!--            :items="[{ text: 'SÍ', value: true }, { text: 'NO', value: false }]"-->
          <!--            :clearable="true"-->
          <!--            row-->
          <!--            :multiple="false"-->
          <!--            :label="$t('¿Tiene Empleados?')"-->
          <!--          ></v-select>-->
        </div>
      </v-flex>
      <v-flex xs12 md2 v-if="showManageModel111">
        <div class="ml-3">
          <v-checkbox
            v-model="manage111Filters.has_professionals"
            label="Tiene profesionales"
          ></v-checkbox>
          <!--          <v-select-->
          <!--            color="primary"-->
          <!--            v-model="manage111Filters.has_professionals"-->
          <!--            item-text="text"-->
          <!--            item-value="value"-->
          <!--            :items="[{ text: 'SÍ', value: true }, { text: 'NO', value: false }]"-->
          <!--            :clearable="true"-->
          <!--            row-->
          <!--            :label="$t('¿Tiene Profesionales?')"-->
          <!--          ></v-select>-->
        </div>
      </v-flex>
      <v-flex xs12 md2 v-if="!showManageModel111">
        <div class="ml-3">
          <v-select
            color="primary"
            v-model="filters.columns"
            item-text="text"
            item-value="value"
            :items="filterColumnsList"
            :clearable="true"
            row
            :multiple="true"
            :label="$t('Mostrar columnas')"
          ></v-select>
        </div>
      </v-flex>
      <v-flex xs12 md2 v-if="!showManageModel111">
        <div class="ml-3">
          <v-select
            color="primary"
            v-model="filters.fiscalStatus"
            item-text="text"
            item-value="value"
            :items="fiscalStatusOptions"
            :clearable="true"
            row
            :label="$t('Estado fiscal')"
          ></v-select>
        </div>
      </v-flex>
      <v-flex xs12 md4>
        <div class="ml-3">
          <v-text-field
            v-model="filters.search"
            append-icon="search"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
        </div>
      </v-flex>
    </v-layout>
    <!-- End filters -->

    <!-- Modal to add new customers -->
    <v-layout row justify-center>
      <v-dialog v-model="showCreateFiscalObligationForm" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">{{ $t('Añadir Empresas') }}</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6>
                  <v-select
                    v-model="form.year"
                    :items="years"
                    :label="$t('Año *')"
                    required
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-select
                    v-model="form.quarter"
                    :items="[
                      { text: 'Trimestre 1', value: 1 },
                      { text: 'Trimestre 2', value: 2 },
                      { text: 'Trimestre 3', value: 3 },
                      { text: 'Trimestre 4', value: 4 },
                      { text: 'Modelo 202', value: 202 },
                    ]"
                    :label="$t('Trimestre / Modelo 202 *')"
                    required
                  ></v-select>
                </v-flex>
                <v-flex xs6>
                  <v-autocomplete
                    v-model="form.consultant_id"
                    :items="consultantsList"
                    :label="$t('Asesor/a *')"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs6>
                  <v-select
                    v-model="form.tax_regime"
                    :items="taxRegimeOptions"
                    :label="$t('Reg. Fiscal *')"
                  ></v-select>
                </v-flex>
                <v-flex xs6>
                  <v-select
                    v-model="form.agency"
                    :items="agencyOptions"
                    :label="$t('Agencia *')"
                  ></v-select>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    v-model="form.prorate"
                    :label="$t('Prorrata')"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-checkbox
                    v-model="form.allCompanies"
                    :label="$t('Añadir todas las empresas activas en este momento')"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs12>
                  <v-autocomplete
                    :disabled="form.allCompanies"
                    v-model="form.companies"
                    :items="companiesList"
                    :label="$t('Empresas *')"
                    multiple
                    chips
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12>
                  <v-textarea
                    :label="$t('Observaciones')"
                    auto-grow
                    :value="form.observations"
                    rows="1"
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>
            <small>{{ $t('* Campos obligatorios') }}</small>
            <v-alert :value="form.showValidationErrors" color="error" icon="warning" outline>
              {{ $t('No has seleccionado todos los campos obligatorios') }}
            </v-alert>
            <v-container v-if="creatingFiscalObligations">
              <v-flex xs12>
                <div class="text-xs-center">
                  <v-progress-circular indeterminate color="primary"></v-progress-circular>
                </div>
              </v-flex>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              :disabled="creatingFiscalObligations"
              color="blue darken-1"
              flat
              @click="showCreateFiscalObligationForm = false"
            >
              {{ $t('Cerrar') }}
            </v-btn>
            <v-btn
              color="primary"
              :disabled="creatingFiscalObligations"
              @click="createFiscalObligations()"
            >
              {{ $t('Añadir') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- End modal -->

    <!-- Modal to delete customers -->
    <v-layout row justify-center>
      <v-dialog v-model="showDeleteFiscalObligationForm" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">{{ $t('Eliminar') }}</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 class="text-xs-center">
                  <h2>¿Estás seguro de eliminar las obligaciones fiscales seleccionadas?</h2>
                  <small>Esta acción no es reversible</small>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="showDeleteFiscalObligationForm = false">
              {{ $t('Cerrar') }}
            </v-btn>
            <v-btn color="error" @click="deleteFiscalObligations()">
              {{ $t('Eliminar') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- End modal -->

    <!-- Modal to clone quarters -->
    <v-layout row justify-center>
      <v-dialog v-model="showCloneQuarterForm" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">{{ $t('Clonar trimestre') }}</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 class="text-xs-center">
                  <h2>Selecciona el año y trimestre que quieres clonar y los datos de destino</h2>
                  <small class="font-weight-bold text-red">
                    Se eliminarán aquellas empresas que ya estén registradas en el trimestre de
                    destino
                  </small>
                </v-flex>
                <v-layout wrap class="mt-4">
                  <v-flex xs12>
                    <h3>ORIGEN</h3>
                  </v-flex>
                  <v-flex xs6>
                    <div class="ml-3">
                      <v-select
                        color="primary"
                        v-model="clone.originYear"
                        item-text="text"
                        item-value="value"
                        :items="years"
                        row
                        :label="$t('Año')"
                      ></v-select>
                    </div>
                  </v-flex>
                  <v-flex xs6>
                    <div class="ml-3">
                      <v-select
                        color="primary"
                        v-model="clone.originQuarter"
                        item-text="text"
                        item-value="value"
                        :items="[
                          { text: 'Trimestre 1', value: '1' },
                          { text: 'Trimestre 2', value: '2' },
                          { text: 'Trimestre 3', value: '3' },
                          { text: 'Trimestre 4', value: '4' },
                          { text: 'Modelo 202', value: '202' },
                        ]"
                        :label="$t('Trimestre / Modelo 202')"
                        row
                      ></v-select>
                    </div>
                  </v-flex>
                </v-layout>
                <v-layout wrap>
                  <v-flex xs12>
                    <h3>DESTINO</h3>
                  </v-flex>
                  <v-flex xs6>
                    <div class="ml-3">
                      <v-select
                        color="primary"
                        v-model="clone.destinyYear"
                        item-text="text"
                        item-value="value"
                        :items="[{ text: nextYear, value: nextYear }].concat(years)"
                        row
                        :label="$t('Año')"
                      ></v-select>
                    </div>
                  </v-flex>
                  <v-flex xs6>
                    <div class="ml-3">
                      <v-select
                        color="primary"
                        v-model="clone.destinyQuarter"
                        item-text="text"
                        item-value="value"
                        :items="[
                          { text: 'Trimestre 1', value: '1' },
                          { text: 'Trimestre 2', value: '2' },
                          { text: 'Trimestre 3', value: '3' },
                          { text: 'Trimestre 4', value: '4' },
                          { text: 'Modelo 202', value: '202' },
                        ]"
                        :label="$t('Trimestre / Modelo 202')"
                        row
                      ></v-select>
                    </div>
                  </v-flex>
                </v-layout>
              </v-layout>
            </v-container>
            <v-alert :value="clone.showValidationErrors" color="error" icon="warning" outline>
              {{ $t('Todos los campos son obligatorios') }}
            </v-alert>
            <v-container v-if="cloningFiscalObligations">
              <v-flex xs12>
                <div class="text-xs-center">
                  <v-progress-circular indeterminate color="primary"></v-progress-circular>
                </div>
              </v-flex>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              flat
              @click="showCloneQuarterForm = false"
              :disabled="cloningFiscalObligations"
            >
              {{ $t('Cerrar') }}
            </v-btn>
            <v-btn
              color="primary"
              @click="cloneFiscalObligations()"
              :disabled="cloningFiscalObligations"
            >
              {{ $t('Clonar') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- End modal -->

    <!-- Modal to bulk edit -->
    <v-layout row justify-center>
      <v-dialog v-model="showBulkEditForm" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">{{ $t('Edición múltiple: ') + bulk.fieldText }}</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 class="text-xs-center">
                  <h3>Se aplicará a todos los elementos seleccionados</h3>
                  <h3 class="text-red" v-if="bulk.fieldValue === 'active'">
                    Si no selecciona ninguna opción se marcarán por defecto como BAJA
                  </h3>
                  <h3 class="text-red" v-if="bulk.fieldValue === 'consultant'">
                    Si no selecciona ninguna opción se eliminarán las asignaciones actuales
                  </h3>
                </v-flex>
                <v-layout wrap class="mt-4">
                  <v-flex xs12>
                    <div class="ml-3">
                      <v-select
                        v-if="bulk.fieldValue && bulk.fieldValue.includes('mod_')"
                        color="primary"
                        v-model="bulk.modelStatus"
                        item-text="text"
                        item-value="value"
                        :items="modelOptions"
                        row
                        :label="$t('Estado del modelo')"
                      ></v-select>
                      <v-autocomplete
                        v-else-if="bulk.fieldValue && bulk.fieldValue.includes('consultant')"
                        color="primary"
                        v-model="bulk.consultant"
                        item-text="text"
                        item-value="value"
                        :items="consultantsList"
                        row
                        :label="$t('Asesor/a')"
                      ></v-autocomplete>
                      <v-select
                        v-else-if="bulk.fieldValue && bulk.fieldValue.includes('active')"
                        color="primary"
                        v-model="bulk.active"
                        item-text="text"
                        item-value="value"
                        :items="[{ text: 'ACTIVO', value: true }, { text: 'BAJA', value: false }]"
                        row
                        :label="$t('Estado Empresa')"
                      ></v-select>
                      <v-select
                        v-else-if="bulk.fieldValue && bulk.fieldValue.includes('status')"
                        color="primary"
                        v-model="bulk.status"
                        item-text="text"
                        item-value="value"
                        :items="fiscalStatusOptions.filter(item => item.value !== 'SIN_DATOS')"
                        row
                        :label="$t('Estado Fiscal')"
                      ></v-select>
                      <v-select
                        v-else-if="bulk.fieldValue && bulk.fieldValue.includes('tax_regime')"
                        color="primary"
                        v-model="bulk.taxRegime"
                        item-text="text"
                        item-value="value"
                        :items="taxRegimeOptions"
                        row
                        :label="$t('Régimen fiscal')"
                      ></v-select>
                      <v-select
                        v-else-if="bulk.fieldValue && bulk.fieldValue.includes('agency')"
                        color="primary"
                        v-model="bulk.agency"
                        item-text="text"
                        item-value="value"
                        :items="agencyOptions"
                        row
                        :label="$t('Agencia')"
                      ></v-select>
                      <v-text-field
                        v-else
                        v-model="bulk.text"
                        :label="$t(`${this.bulk.fieldText}`)"
                      ></v-text-field>
                    </div>
                  </v-flex>
                </v-layout>
              </v-layout>
            </v-container>
            <v-container v-if="bulkSavingFiscalObligations">
              <v-flex xs12>
                <div class="text-xs-center">
                  <v-progress-circular indeterminate color="primary"></v-progress-circular>
                </div>
              </v-flex>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              flat
              @click="showBulkEditForm = false"
              :disabled="bulkSavingFiscalObligations"
            >
              {{ $t('Cerrar') }}
            </v-btn>
            <v-btn
              color="primary"
              @click="saveBulkEditForm()"
              :disabled="bulkSavingFiscalObligations"
            >
              {{ $t('Guardar') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- End modal -->

    <!-- Data table with fiscal obligations -->
    <v-data-table
      v-if="!showManageModel111"
      ref="fiscalObligationsTable"
      v-model="selectedItems"
      :loading="loading"
      :headers="headers"
      :items="fiscalObligations"
      :pagination.sync="fObligationsPagination"
      :rows-per-page-items="[10, 20, 30, 50, 100]"
      :total-items="fObligationsPagination.totalItems"
      select-all
    >
      <template v-slot:no-data>
        <v-alert :value="true" color="info" icon="info" outline>
          {{ $t('No hay información que mostrar con los filtros seleccionados :(') }}
        </v-alert>
      </template>
      <template v-slot:headers="props">
        <tr>
          <th v-if="props.headers.length > 0">
            <v-checkbox
              v-model="selectAllRows"
              @change="selectAllTableRows()"
              primary
              hide-details
            ></v-checkbox>
          </th>
          <template v-for="header in props.headers">
            <!-- Filter selected columns -->
            <template
              v-if="filters.columns.includes('all') || filters.columns.includes(header.value)"
            >
              <template
                v-if="
                  !header.value.includes('mod_') ||
                    (header.value.includes('mod_') &&
                      !header.value.includes('202_') &&
                      quarter !== '202') ||
                    (header.value.includes('202_') && quarter === '202')
                "
              >
                <th
                  :key="`th_${header.value}`"
                  :class="[
                    'text-xs-center',
                    header.sortable ? 'column sortable' : '',
                    fObligationsPagination.descending ? 'desc' : 'asc',
                    header.value === fObligationsPagination.sortBy ? 'active' : '',
                  ]"
                  @click="
                    header.sortable
                      ? changeSort(header.value)
                      : openBulkEditForm(header.text, header.value)
                  "
                >
                  <v-icon v-if="header.sortable" small>arrow_upward</v-icon>
                  {{ header.text }}
                </th>
              </template>
            </template>
            <!-- End filter selected columnas -->
          </template>
        </tr>
      </template>
      <template v-slot:items="props">
        <tr :style="!props.item.active ? 'background-color: pink' : ''">
          <td>
            <v-checkbox v-model="props.selected" primary hide-details></v-checkbox>
          </td>
          <!--          <td class="text-xs-center">{{ props.item.id }}</td>-->
          <td
            class="text-xs-center"
            v-if="filters.columns.includes('all') || filters.columns.includes('clavedat')"
          >
            {{ props.item.clavedat }}
          </td>
          <td
            class="text-xs-center"
            v-if="filters.columns.includes('all') || filters.columns.includes('name')"
          >
            {{ props.item.name }}
          </td>
          <td
            class="text-xs-center"
            v-if="filters.columns.includes('all') || filters.columns.includes('cif')"
          >
            {{ props.item.cif }}
          </td>
          <td
            class="text-xs-center"
            v-if="filters.columns.includes('all') || filters.columns.includes('consultant')"
          >
            <div v-if="isBeingReviewed && !canReviewFiscalObligations">
              {{ props.item.consultant }}
            </div>
            <v-edit-dialog
              v-else
              :return-value.sync="props.item.consultant_id"
              large
              lazy
              persistent
              @save="saveRow(props.item)"
              @cancel="cancelSaveRow(props.item)"
            >
              <div>{{ props.item.consultant }}</div>
              <template v-slot:input>
                <div class="mt-3">Asesor/a</div>
                <v-select
                  color="primary"
                  v-model="props.item.consultant_id"
                  item-text="text"
                  item-value="value"
                  :items="consultantsList"
                  row
                ></v-select>
              </template>
            </v-edit-dialog>
          </td>
          <!--          <td class="text-xs-center">-->
          <!--            <v-edit-dialog-->
          <!--              :return-value.sync="props.item.year"-->
          <!--              large-->
          <!--              lazy-->
          <!--              persistent-->
          <!--              @save="saveRow(props.item)"-->
          <!--              @cancel="cancelSaveRow()"-->
          <!--            >-->
          <!--              <div>{{ props.item.year }}</div>-->
          <!--              <template v-slot:input>-->
          <!--                <div class="mt-3">Año</div>-->
          <!--                <v-select-->
          <!--                  color="primary"-->
          <!--                  v-model="props.item.year"-->
          <!--                  item-text="text"-->
          <!--                  item-value="value"-->
          <!--                  :items="years"-->
          <!--                  row-->
          <!--                ></v-select>-->
          <!--              </template>-->
          <!--            </v-edit-dialog>-->
          <!--          </td>-->
          <!--          <td class="text-xs-center">-->
          <!--            <v-edit-dialog-->
          <!--              :return-value.sync="props.item.quarter"-->
          <!--              large-->
          <!--              lazy-->
          <!--              persistent-->
          <!--              @save="saveRow(props.item)"-->
          <!--              @cancel="cancelSaveRow()"-->
          <!--            >-->
          <!--              <div>-->
          <!--                {{-->
          <!--                  props.item.quarter === 202-->
          <!--                    ? `Modelo ${props.item.quarter}`-->
          <!--                    : `Trimestre ${props.item.quarter}`-->
          <!--                }}-->
          <!--              </div>-->
          <!--              <template v-slot:input>-->
          <!--                <div class="mt-3">Trimestre/Mod.202</div>-->
          <!--                <v-select-->
          <!--                  color="primary"-->
          <!--                  v-model="props.item.quarter"-->
          <!--                  item-text="text"-->
          <!--                  item-value="value"-->
          <!--                  :items="[-->
          <!--                    { text: 'Trimestre 1', value: 1 },-->
          <!--                    { text: 'Trimestre 2', value: 2 },-->
          <!--                    { text: 'Trimestre 3', value: 3 },-->
          <!--                    { text: 'Trimestre 4', value: 4 },-->
          <!--                    { text: 'Modelo 202', value: 202 },-->
          <!--                  ]"-->
          <!--                  row-->
          <!--                ></v-select>-->
          <!--              </template>-->
          <!--            </v-edit-dialog>-->
          <!--          </td>-->
          <td
            class="text-xs-center"
            v-if="filters.columns.includes('all') || filters.columns.includes('tax_regime')"
          >
            <div v-if="isBeingReviewed && !canReviewFiscalObligations">
              {{ props.item.tax_regime }}
            </div>
            <v-edit-dialog
              v-else
              :return-value.sync="props.item.tax_regime"
              large
              lazy
              persistent
              @save="saveRow(props.item)"
              @cancel="cancelSaveRow()"
            >
              <div>{{ props.item.tax_regime }}</div>
              <template v-slot:input>
                <div class="mt-3">Régimen Fiscal</div>
                <v-select
                  color="primary"
                  v-model="props.item.tax_regime"
                  item-text="text"
                  item-value="value"
                  :items="taxRegimeOptions"
                  row
                ></v-select>
              </template>
            </v-edit-dialog>
          </td>
          <td
            class="text-xs-center"
            v-if="filters.columns.includes('all') || filters.columns.includes('agency')"
          >
            <div v-if="isBeingReviewed && !canReviewFiscalObligations">{{ props.item.agency }}</div>
            <v-edit-dialog
              v-else
              :return-value.sync="props.item.agency"
              large
              lazy
              persistent
              @save="saveRow(props.item)"
              @cancel="cancelSaveRow()"
            >
              <div>{{ props.item.agency }}</div>
              <template v-slot:input>
                <div class="mt-3">Agencia</div>
                <v-select
                  color="primary"
                  v-model="props.item.agency"
                  item-text="text"
                  item-value="value"
                  :items="agencyOptions"
                  row
                ></v-select>
              </template>
            </v-edit-dialog>
          </td>
          <td
            class="text-xs-center"
            v-if="filters.columns.includes('all') || filters.columns.includes('prorate')"
          >
            <div v-if="isBeingReviewed && !canReviewFiscalObligations">
              {{ props.item.prorate }}
            </div>
            <v-edit-dialog
              v-else
              :return-value.sync="props.item.prorate"
              large
              lazy
              persistent
              @save="saveRow(props.item)"
              @cancel="cancelSaveRow()"
            >
              <div>{{ props.item.prorate }}</div>
              <template v-slot:input>
                <div class="mt-3">Prorrata</div>
                <v-text-field v-model="props.item.prorate" single-line autofocus></v-text-field>
              </template>
            </v-edit-dialog>
          </td>
          <td
            class="text-xs-center"
            v-if="filters.columns.includes('all') || filters.columns.includes('status')"
          >
            <div v-if="isBeingReviewed && !canReviewFiscalObligations">{{ props.item.status }}</div>
            <v-edit-dialog
              v-else
              :return-value.sync="props.item.status"
              large
              lazy
              persistent
              @save="saveRow(props.item)"
              @cancel="cancelSaveRow()"
            >
              <div>{{ props.item.status }}</div>
              <template v-slot:input>
                <div class="mt-3">Estado Fiscal</div>
                <v-select
                  color="primary"
                  v-model="props.item.status"
                  item-text="text"
                  item-value="value"
                  :items="fiscalStatusOptions.filter(item => item.value !== 'SIN_DATOS')"
                  row
                ></v-select>
              </template>
            </v-edit-dialog>
          </td>
          <td
            class="text-xs-center"
            v-if="filters.columns.includes('all') || filters.columns.includes('active')"
          >
            <div v-if="isBeingReviewed && !canReviewFiscalObligations">
              {{ props.item.active_text }}
            </div>
            <v-edit-dialog
              v-else
              :return-value.sync="props.item.active"
              large
              lazy
              persistent
              @save="saveRow(props.item)"
              @cancel="cancelSaveRow()"
            >
              <div>{{ props.item.active_text }}</div>
              <template v-slot:input>
                <div class="mt-3">Estado Empresa</div>
                <v-select
                  color="primary"
                  v-model="props.item.active"
                  item-text="text"
                  item-value="value"
                  :items="[{ text: 'ACTIVO', value: true }, { text: 'BAJA', value: false }]"
                  row
                ></v-select>
              </template>
            </v-edit-dialog>
          </td>
          <td
            class="text-xs-center"
            v-if="filters.columns.includes('all') || filters.columns.includes('observations')"
          >
            <div v-if="isBeingReviewed && !canReviewFiscalObligations">
              {{ props.item.observations }}
            </div>
            <v-edit-dialog
              v-else
              :return-value.sync="props.item.observations"
              large
              lazy
              persistent
              @save="saveRow(props.item)"
              @cancel="cancelSaveRow()"
            >
              <div>{{ props.item.observations }}</div>
              <template v-slot:input>
                <div class="mt-3">Observaciones</div>
                <v-text-field
                  v-model="props.item.observations"
                  single-line
                  autofocus
                ></v-text-field>
              </template>
            </v-edit-dialog>
          </td>
          <!--          <td-->
          <!--            class="text-xs-center"-->
          <!--            v-if="quarter !== '202'"-->
          <!--            :bgcolor="getBgColorForModelEntries(props.item.mod_110)"-->
          <!--          >-->
          <!--            <v-edit-dialog-->
          <!--              :return-value.sync="props.item.mod_110"-->
          <!--              large-->
          <!--              lazy-->
          <!--              persistent-->
          <!--              @save="saveRow(props.item)"-->
          <!--              @cancel="cancelSaveRow()"-->
          <!--            >-->
          <!--              <div>{{ props.item.mod_110 }}</div>-->
          <!--              <template v-slot:input>-->
          <!--                <div class="mt-3">Modelo 110</div>-->
          <!--                <v-select-->
          <!--                  color="primary"-->
          <!--                  v-model="props.item.mod_110"-->
          <!--                  item-text="text"-->
          <!--                  item-value="value"-->
          <!--                  :items="modelOptions"-->
          <!--                  row-->
          <!--                ></v-select>-->
          <!--              </template>-->
          <!--            </v-edit-dialog>-->
          <!--          </td>-->
          <td
            class="text-xs-center"
            v-if="
              quarter !== '202' &&
                (filters.columns.includes('all') || filters.columns.includes('mod_111'))
            "
            :bgcolor="getBgColorForModelEntries(props.item.mod_111)"
          >
            <div v-if="isBeingReviewed && !canReviewFiscalObligations">
              {{ props.item.mod_111 }}
            </div>
            <v-edit-dialog
              v-else
              :return-value.sync="props.item.mod_111"
              large
              lazy
              persistent
              @save="saveRow(props.item)"
              @cancel="cancelSaveRow()"
            >
              <div>{{ props.item.mod_111 }}</div>
              <template v-slot:input>
                <div class="mt-3">Modelo 111</div>
                <v-select
                  color="primary"
                  v-model="props.item.mod_111"
                  item-text="text"
                  item-value="value"
                  :items="modelOptions"
                  row
                ></v-select>
              </template>
            </v-edit-dialog>
          </td>
          <td
            class="text-xs-center"
            v-if="
              quarter !== '202' &&
                (filters.columns.includes('all') || filters.columns.includes('mod_115'))
            "
            :bgcolor="getBgColorForModelEntries(props.item.mod_115)"
          >
            <div v-if="isBeingReviewed && !canReviewFiscalObligations">
              {{ props.item.mod_115 }}
            </div>
            <v-edit-dialog
              v-else
              :return-value.sync="props.item.mod_115"
              large
              lazy
              persistent
              @save="saveRow(props.item)"
              @cancel="cancelSaveRow()"
            >
              <div>{{ props.item.mod_115 }}</div>
              <template v-slot:input>
                <div class="mt-3">Modelo 115</div>
                <v-select
                  color="primary"
                  v-model="props.item.mod_115"
                  item-text="text"
                  item-value="value"
                  :items="modelOptions"
                  row
                ></v-select>
              </template>
            </v-edit-dialog>
          </td>
          <td
            class="text-xs-center"
            v-if="
              quarter !== '202' &&
                (filters.columns.includes('all') || filters.columns.includes('mod_123'))
            "
            :bgcolor="getBgColorForModelEntries(props.item.mod_123)"
          >
            <div v-if="isBeingReviewed && !canReviewFiscalObligations">
              {{ props.item.mod_123 }}
            </div>
            <v-edit-dialog
              v-else
              :return-value.sync="props.item.mod_123"
              large
              lazy
              persistent
              @save="saveRow(props.item)"
              @cancel="cancelSaveRow()"
            >
              <div>{{ props.item.mod_123 }}</div>
              <template v-slot:input>
                <div class="mt-3">Modelo 123</div>
                <v-select
                  color="primary"
                  v-model="props.item.mod_123"
                  item-text="text"
                  item-value="value"
                  :items="modelOptions"
                  row
                ></v-select>
              </template>
            </v-edit-dialog>
          </td>
          <td
            class="text-xs-center"
            v-if="
              quarter !== '202' &&
                (filters.columns.includes('all') || filters.columns.includes('mod_130'))
            "
            :bgcolor="getBgColorForModelEntries(props.item.mod_130)"
          >
            <div v-if="isBeingReviewed && !canReviewFiscalObligations">
              {{ props.item.mod_130 }}
            </div>
            <v-edit-dialog
              v-else
              :return-value.sync="props.item.mod_130"
              large
              lazy
              persistent
              @save="saveRow(props.item)"
              @cancel="cancelSaveRow()"
            >
              <div>{{ props.item.mod_130 }}</div>
              <template v-slot:input>
                <div class="mt-3">Modelo 130</div>
                <v-select
                  color="primary"
                  v-model="props.item.mod_130"
                  item-text="text"
                  item-value="value"
                  :items="modelOptions"
                  row
                ></v-select>
              </template>
            </v-edit-dialog>
          </td>
          <td
            class="text-xs-center"
            v-if="
              quarter !== '202' &&
                (filters.columns.includes('all') || filters.columns.includes('mod_131'))
            "
            :bgcolor="getBgColorForModelEntries(props.item.mod_131)"
          >
            <div v-if="isBeingReviewed && !canReviewFiscalObligations">
              {{ props.item.mod_131 }}
            </div>
            <v-edit-dialog
              v-else
              :return-value.sync="props.item.mod_131"
              large
              lazy
              persistent
              @save="saveRow(props.item)"
              @cancel="cancelSaveRow()"
            >
              <div>{{ props.item.mod_131 }}</div>
              <template v-slot:input>
                <div class="mt-3">Modelo 131</div>
                <v-select
                  color="primary"
                  v-model="props.item.mod_131"
                  item-text="text"
                  item-value="value"
                  :items="modelOptions"
                  row
                ></v-select>
              </template>
            </v-edit-dialog>
          </td>
          <td
            class="text-xs-center"
            v-if="
              quarter !== '202' &&
                (filters.columns.includes('all') || filters.columns.includes('mod_140'))
            "
            :bgcolor="getBgColorForModelEntries(props.item.mod_140)"
          >
            <div v-if="isBeingReviewed && !canReviewFiscalObligations">
              {{ props.item.mod_140 }}
            </div>
            <v-edit-dialog
              v-else
              :return-value.sync="props.item.mod_140"
              large
              lazy
              persistent
              @save="saveRow(props.item)"
              @cancel="cancelSaveRow()"
            >
              <div>{{ props.item.mod_140 }}</div>
              <template v-slot:input>
                <div class="mt-3">Modelo 140</div>
                <v-select
                  color="primary"
                  v-model="props.item.mod_140"
                  item-text="text"
                  item-value="value"
                  :items="modelOptions"
                  row
                ></v-select>
              </template>
            </v-edit-dialog>
          </td>
          <td
            class="text-xs-center"
            v-if="
              quarter !== '202' &&
                (filters.columns.includes('all') || filters.columns.includes('mod_165'))
            "
            :bgcolor="getBgColorForModelEntries(props.item.mod_165)"
          >
            <div v-if="isBeingReviewed && !canReviewFiscalObligations">
              {{ props.item.mod_165 }}
            </div>
            <v-edit-dialog
              v-else
              :return-value.sync="props.item.mod_165"
              large
              lazy
              persistent
              @save="saveRow(props.item)"
              @cancel="cancelSaveRow()"
            >
              <div>{{ props.item.mod_165 }}</div>
              <template v-slot:input>
                <div class="mt-3">Modelo 165</div>
                <v-select
                  color="primary"
                  v-model="props.item.mod_165"
                  item-text="text"
                  item-value="value"
                  :items="modelOptions"
                  row
                ></v-select>
              </template>
            </v-edit-dialog>
          </td>
          <td
            class="text-xs-center"
            v-if="
              quarter !== '202' &&
                (filters.columns.includes('all') || filters.columns.includes('mod_179'))
            "
            :bgcolor="getBgColorForModelEntries(props.item.mod_179)"
          >
            <div v-if="isBeingReviewed && !canReviewFiscalObligations">
              {{ props.item.mod_179 }}
            </div>
            <v-edit-dialog
              v-else
              :return-value.sync="props.item.mod_179"
              large
              lazy
              persistent
              @save="saveRow(props.item)"
              @cancel="cancelSaveRow()"
            >
              <div>{{ props.item.mod_179 }}</div>
              <template v-slot:input>
                <div class="mt-3">Modelo 179</div>
                <v-select
                  color="primary"
                  v-model="props.item.mod_179"
                  item-text="text"
                  item-value="value"
                  :items="modelOptions"
                  row
                ></v-select>
              </template>
            </v-edit-dialog>
          </td>
          <td
            class="text-xs-center"
            v-if="
              quarter !== '202' &&
                (filters.columns.includes('all') || filters.columns.includes('mod_180'))
            "
            :bgcolor="getBgColorForModelEntries(props.item.mod_180)"
          >
            <div v-if="isBeingReviewed && !canReviewFiscalObligations">
              {{ props.item.mod_180 }}
            </div>
            <v-edit-dialog
              v-else
              :return-value.sync="props.item.mod_180"
              large
              lazy
              persistent
              @save="saveRow(props.item)"
              @cancel="cancelSaveRow()"
            >
              <div>{{ props.item.mod_180 }}</div>
              <template v-slot:input>
                <div class="mt-3">Modelo 180</div>
                <v-select
                  color="primary"
                  v-model="props.item.mod_180"
                  item-text="text"
                  item-value="value"
                  :items="modelOptions"
                  row
                ></v-select>
              </template>
            </v-edit-dialog>
          </td>
          <td
            class="text-xs-center"
            v-if="
              quarter !== '202' &&
                (filters.columns.includes('all') || filters.columns.includes('mod_182'))
            "
            :bgcolor="getBgColorForModelEntries(props.item.mod_182)"
          >
            <div v-if="isBeingReviewed && !canReviewFiscalObligations">
              {{ props.item.mod_182 }}
            </div>
            <v-edit-dialog
              v-else
              :return-value.sync="props.item.mod_182"
              large
              lazy
              persistent
              @save="saveRow(props.item)"
              @cancel="cancelSaveRow()"
            >
              <div>{{ props.item.mod_182 }}</div>
              <template v-slot:input>
                <div class="mt-3">Modelo 182</div>
                <v-select
                  color="primary"
                  v-model="props.item.mod_182"
                  item-text="text"
                  item-value="value"
                  :items="modelOptions"
                  row
                ></v-select>
              </template>
            </v-edit-dialog>
          </td>
          <td
            class="text-xs-center"
            v-if="
              quarter !== '202' &&
                (filters.columns.includes('all') || filters.columns.includes('mod_184'))
            "
            :bgcolor="getBgColorForModelEntries(props.item.mod_184)"
          >
            <div v-if="isBeingReviewed && !canReviewFiscalObligations">
              {{ props.item.mod_184 }}
            </div>
            <v-edit-dialog
              v-else
              :return-value.sync="props.item.mod_184"
              large
              lazy
              persistent
              @save="saveRow(props.item)"
              @cancel="cancelSaveRow()"
            >
              <div>{{ props.item.mod_184 }}</div>
              <template v-slot:input>
                <div class="mt-3">Modelo 184</div>
                <v-select
                  color="primary"
                  v-model="props.item.mod_184"
                  item-text="text"
                  item-value="value"
                  :items="modelOptions"
                  row
                ></v-select>
              </template>
            </v-edit-dialog>
          </td>
          <td
            class="text-xs-center"
            v-if="
              quarter !== '202' &&
                (filters.columns.includes('all') || filters.columns.includes('mod_190'))
            "
            :bgcolor="getBgColorForModelEntries(props.item.mod_190)"
          >
            <div v-if="isBeingReviewed && !canReviewFiscalObligations">
              {{ props.item.mod_190 }}
            </div>
            <v-edit-dialog
              v-else
              :return-value.sync="props.item.mod_190"
              large
              lazy
              persistent
              @save="saveRow(props.item)"
              @cancel="cancelSaveRow()"
            >
              <div>{{ props.item.mod_190 }}</div>
              <template v-slot:input>
                <div class="mt-3">Modelo 190</div>
                <v-select
                  color="primary"
                  v-model="props.item.mod_190"
                  item-text="text"
                  item-value="value"
                  :items="modelOptions"
                  row
                ></v-select>
              </template>
            </v-edit-dialog>
          </td>
          <td
            class="text-xs-center"
            v-if="
              quarter !== '202' &&
                (filters.columns.includes('all') || filters.columns.includes('mod_193'))
            "
            :bgcolor="getBgColorForModelEntries(props.item.mod_193)"
          >
            <div v-if="isBeingReviewed && !canReviewFiscalObligations">
              {{ props.item.mod_193 }}
            </div>
            <v-edit-dialog
              v-else
              :return-value.sync="props.item.mod_193"
              large
              lazy
              persistent
              @save="saveRow(props.item)"
              @cancel="cancelSaveRow()"
            >
              <div>{{ props.item.mod_193 }}</div>
              <template v-slot:input>
                <div class="mt-3">Modelo 193</div>
                <v-select
                  color="primary"
                  v-model="props.item.mod_193"
                  item-text="text"
                  item-value="value"
                  :items="modelOptions"
                  row
                ></v-select>
              </template>
            </v-edit-dialog>
          </td>
          <td
            class="text-xs-center"
            v-if="
              quarter === '202' &&
                (filters.columns.includes('all') || filters.columns.includes('mod_202_1P'))
            "
            :bgcolor="getBgColorForModelEntries(props.item.mod_202_1P)"
          >
            <div v-if="isBeingReviewed && !canReviewFiscalObligations">
              {{ props.item.mod_202_1P }}
            </div>
            <v-edit-dialog
              v-else
              :return-value.sync="props.item.mod_202_1P"
              large
              lazy
              persistent
              @save="saveRow(props.item)"
              @cancel="cancelSaveRow()"
            >
              <div>{{ props.item.mod_202_1P }}</div>
              <template v-slot:input>
                <div class="mt-3">Modelo 202 1P</div>
                <v-select
                  color="primary"
                  v-model="props.item.mod_202_1P"
                  item-text="text"
                  item-value="value"
                  :items="modelOptions"
                  row
                ></v-select>
              </template>
            </v-edit-dialog>
          </td>
          <td
            class="text-xs-center"
            v-if="
              quarter === '202' &&
                (filters.columns.includes('all') || filters.columns.includes('mod_202_2P'))
            "
            :bgcolor="getBgColorForModelEntries(props.item.mod_202_2P)"
          >
            <div v-if="isBeingReviewed && !canReviewFiscalObligations">
              {{ props.item.mod_202_2P }}
            </div>
            <v-edit-dialog
              v-else
              :return-value.sync="props.item.mod_202_2P"
              large
              lazy
              persistent
              @save="saveRow(props.item)"
              @cancel="cancelSaveRow()"
            >
              <div>{{ props.item.mod_202_2P }}</div>
              <template v-slot:input>
                <div class="mt-3">Modelo 202 2P</div>
                <v-select
                  color="primary"
                  v-model="props.item.mod_202_2P"
                  item-text="text"
                  item-value="value"
                  :items="modelOptions"
                  row
                ></v-select>
              </template>
            </v-edit-dialog>
          </td>
          <td
            class="text-xs-center"
            v-if="
              quarter === '202' &&
                (filters.columns.includes('all') || filters.columns.includes('mod_202_3P'))
            "
            :bgcolor="getBgColorForModelEntries(props.item.mod_202_3P)"
          >
            <div v-if="isBeingReviewed && !canReviewFiscalObligations">
              {{ props.item.mod_202_3P }}
            </div>
            <v-edit-dialog
              v-else
              :return-value.sync="props.item.mod_202_3P"
              large
              lazy
              persistent
              @save="saveRow(props.item)"
              @cancel="cancelSaveRow()"
            >
              <div>{{ props.item.mod_202_3P }}</div>
              <template v-slot:input>
                <div class="mt-3">Modelo 202 3P</div>
                <v-select
                  color="primary"
                  v-model="props.item.mod_202_3P"
                  item-text="text"
                  item-value="value"
                  :items="modelOptions"
                  row
                ></v-select>
              </template>
            </v-edit-dialog>
          </td>
          <td
            class="text-xs-center"
            v-if="
              quarter !== '202' &&
                (filters.columns.includes('all') || filters.columns.includes('mod_210'))
            "
            :bgcolor="getBgColorForModelEntries(props.item.mod_210)"
          >
            <div v-if="isBeingReviewed && !canReviewFiscalObligations">
              {{ props.item.mod_210 }}
            </div>
            <v-edit-dialog
              v-else
              :return-value.sync="props.item.mod_210"
              large
              lazy
              persistent
              @save="saveRow(props.item)"
              @cancel="cancelSaveRow()"
            >
              <div>{{ props.item.mod_210 }}</div>
              <template v-slot:input>
                <div class="mt-3">Modelo 210</div>
                <v-select
                  color="primary"
                  v-model="props.item.mod_210"
                  item-text="text"
                  item-value="value"
                  :items="modelOptions"
                  row
                ></v-select>
              </template>
            </v-edit-dialog>
          </td>
          <td
            class="text-xs-center"
            v-if="
              quarter !== '202' &&
                (filters.columns.includes('all') || filters.columns.includes('mod_216'))
            "
            :bgcolor="getBgColorForModelEntries(props.item.mod_216)"
          >
            <div v-if="isBeingReviewed && !canReviewFiscalObligations">
              {{ props.item.mod_216 }}
            </div>
            <v-edit-dialog
              v-else
              :return-value.sync="props.item.mod_216"
              large
              lazy
              persistent
              @save="saveRow(props.item)"
              @cancel="cancelSaveRow()"
            >
              <div>{{ props.item.mod_216 }}</div>
              <template v-slot:input>
                <div class="mt-3">Modelo 216</div>
                <v-select
                  color="primary"
                  v-model="props.item.mod_216"
                  item-text="text"
                  item-value="value"
                  :items="modelOptions"
                  row
                ></v-select>
              </template>
            </v-edit-dialog>
          </td>
          <td
            class="text-xs-center"
            v-if="
              quarter !== '202' &&
                (filters.columns.includes('all') || filters.columns.includes('mod_232'))
            "
            :bgcolor="getBgColorForModelEntries(props.item.mod_232)"
          >
            <div v-if="isBeingReviewed && !canReviewFiscalObligations">
              {{ props.item.mod_232 }}
            </div>
            <v-edit-dialog
              v-else
              :return-value.sync="props.item.mod_232"
              large
              lazy
              persistent
              @save="saveRow(props.item)"
              @cancel="cancelSaveRow()"
            >
              <div>{{ props.item.mod_232 }}</div>
              <template v-slot:input>
                <div class="mt-3">Modelo 232</div>
                <v-select
                  color="primary"
                  v-model="props.item.mod_232"
                  item-text="text"
                  item-value="value"
                  :items="modelOptions"
                  row
                ></v-select>
              </template>
            </v-edit-dialog>
          </td>
          <td
            class="text-xs-center"
            v-if="
              quarter !== '202' &&
                (filters.columns.includes('all') || filters.columns.includes('mod_233'))
            "
            :bgcolor="getBgColorForModelEntries(props.item.mod_233)"
          >
            <div v-if="isBeingReviewed && !canReviewFiscalObligations">
              {{ props.item.mod_233 }}
            </div>
            <v-edit-dialog
              v-else
              :return-value.sync="props.item.mod_233"
              large
              lazy
              persistent
              @save="saveRow(props.item)"
              @cancel="cancelSaveRow()"
            >
              <div>{{ props.item.mod_233 }}</div>
              <template v-slot:input>
                <div class="mt-3">Modelo 233</div>
                <v-select
                  color="primary"
                  v-model="props.item.mod_233"
                  item-text="text"
                  item-value="value"
                  :items="modelOptions"
                  row
                ></v-select>
              </template>
            </v-edit-dialog>
          </td>
          <td
            class="text-xs-center"
            v-if="
              quarter !== '202' &&
                (filters.columns.includes('all') || filters.columns.includes('mod_296'))
            "
            :bgcolor="getBgColorForModelEntries(props.item.mod_296)"
          >
            <div v-if="isBeingReviewed && !canReviewFiscalObligations">
              {{ props.item.mod_296 }}
            </div>
            <v-edit-dialog
              v-else
              :return-value.sync="props.item.mod_296"
              large
              lazy
              persistent
              @save="saveRow(props.item)"
              @cancel="cancelSaveRow()"
            >
              <div>{{ props.item.mod_296 }}</div>
              <template v-slot:input>
                <div class="mt-3">Modelo 296</div>
                <v-select
                  color="primary"
                  v-model="props.item.mod_296"
                  item-text="text"
                  item-value="value"
                  :items="modelOptions"
                  row
                ></v-select>
              </template>
            </v-edit-dialog>
          </td>
          <!--          <td-->
          <!--            class="text-xs-center"-->
          <!--            v-if="quarter !== '202'"-->
          <!--            :bgcolor="getBgColorForModelEntries(props.item.mod_300)"-->
          <!--          >-->
          <!--            <v-edit-dialog-->
          <!--              :return-value.sync="props.item.mod_300"-->
          <!--              large-->
          <!--              lazy-->
          <!--              persistent-->
          <!--              @save="saveRow(props.item)"-->
          <!--              @cancel="cancelSaveRow()"-->
          <!--            >-->
          <!--              <div>{{ props.item.mod_300 }}</div>-->
          <!--              <template v-slot:input>-->
          <!--                <div class="mt-3">Modelo 300</div>-->
          <!--                <v-select-->
          <!--                  color="primary"-->
          <!--                  v-model="props.item.mod_300"-->
          <!--                  item-text="text"-->
          <!--                  item-value="value"-->
          <!--                  :items="modelOptions"-->
          <!--                  row-->
          <!--                ></v-select>-->
          <!--              </template>-->
          <!--            </v-edit-dialog>-->
          <!--          </td>-->
          <td
            class="text-xs-center"
            v-if="
              quarter !== '202' &&
                (filters.columns.includes('all') || filters.columns.includes('mod_303'))
            "
            :bgcolor="getBgColorForModelEntries(props.item.mod_303)"
          >
            <div v-if="isBeingReviewed && !canReviewFiscalObligations">
              {{ props.item.mod_303 }}
            </div>
            <v-edit-dialog
              v-else
              :return-value.sync="props.item.mod_303"
              large
              lazy
              persistent
              @save="saveRow(props.item)"
              @cancel="cancelSaveRow()"
            >
              <div>{{ props.item.mod_303 }}</div>
              <template v-slot:input>
                <div class="mt-3">Modelo 303</div>
                <v-select
                  color="primary"
                  v-model="props.item.mod_303"
                  item-text="text"
                  item-value="value"
                  :items="modelOptions"
                  row
                ></v-select>
              </template>
            </v-edit-dialog>
          </td>
          <td
            class="text-xs-center"
            v-if="
              quarter !== '202' &&
                (filters.columns.includes('all') || filters.columns.includes('mod_309'))
            "
            :bgcolor="getBgColorForModelEntries(props.item.mod_309)"
          >
            <div v-if="isBeingReviewed && !canReviewFiscalObligations">
              {{ props.item.mod_309 }}
            </div>
            <v-edit-dialog
              v-else
              :return-value.sync="props.item.mod_309"
              large
              lazy
              persistent
              @save="saveRow(props.item)"
              @cancel="cancelSaveRow()"
            >
              <div>{{ props.item.mod_309 }}</div>
              <template v-slot:input>
                <div class="mt-3">Modelo 309</div>
                <v-select
                  color="primary"
                  v-model="props.item.mod_309"
                  item-text="text"
                  item-value="value"
                  :items="modelOptions"
                  row
                ></v-select>
              </template>
            </v-edit-dialog>
          </td>
          <td
            class="text-xs-center"
            v-if="
              quarter !== '202' &&
                (filters.columns.includes('all') || filters.columns.includes('mod_310'))
            "
            :bgcolor="getBgColorForModelEntries(props.item.mod_310)"
          >
            <div v-if="isBeingReviewed && !canReviewFiscalObligations">
              {{ props.item.mod_310 }}
            </div>
            <v-edit-dialog
              v-else
              :return-value.sync="props.item.mod_310"
              large
              lazy
              persistent
              @save="saveRow(props.item)"
              @cancel="cancelSaveRow()"
            >
              <div>{{ props.item.mod_310 }}</div>
              <template v-slot:input>
                <div class="mt-3">Modelo 310</div>
                <v-select
                  color="primary"
                  v-model="props.item.mod_310"
                  item-text="text"
                  item-value="value"
                  :items="modelOptions"
                  row
                ></v-select>
              </template>
            </v-edit-dialog>
          </td>
          <td
            class="text-xs-center"
            v-if="
              quarter !== '202' &&
                (filters.columns.includes('all') || filters.columns.includes('mod_330'))
            "
            :bgcolor="getBgColorForModelEntries(props.item.mod_330)"
          >
            <div v-if="isBeingReviewed && !canReviewFiscalObligations">
              {{ props.item.mod_330 }}
            </div>
            <v-edit-dialog
              v-else
              :return-value.sync="props.item.mod_330"
              large
              lazy
              persistent
              @save="saveRow(props.item)"
              @cancel="cancelSaveRow()"
            >
              <div>{{ props.item.mod_330 }}</div>
              <template v-slot:input>
                <div class="mt-3">Modelo 330</div>
                <v-select
                  color="primary"
                  v-model="props.item.mod_330"
                  item-text="text"
                  item-value="value"
                  :items="modelOptions"
                  row
                ></v-select>
              </template>
            </v-edit-dialog>
          </td>
          <td
            class="text-xs-center"
            v-if="
              quarter !== '202' &&
                (filters.columns.includes('all') || filters.columns.includes('mod_332'))
            "
            :bgcolor="getBgColorForModelEntries(props.item.mod_332)"
          >
            <div v-if="isBeingReviewed && !canReviewFiscalObligations">
              {{ props.item.mod_332 }}
            </div>
            <v-edit-dialog
              v-else
              :return-value.sync="props.item.mod_332"
              large
              lazy
              persistent
              @save="saveRow(props.item)"
              @cancel="cancelSaveRow()"
            >
              <div>{{ props.item.mod_332 }}</div>
              <template v-slot:input>
                <div class="mt-3">Modelo 332</div>
                <v-select
                  color="primary"
                  v-model="props.item.mod_332"
                  item-text="text"
                  item-value="value"
                  :items="modelOptions"
                  row
                ></v-select>
              </template>
            </v-edit-dialog>
          </td>
          <td
            class="text-xs-center"
            v-if="
              quarter !== '202' &&
                (filters.columns.includes('all') || filters.columns.includes('mod_340'))
            "
            :bgcolor="getBgColorForModelEntries(props.item.mod_340)"
          >
            <div v-if="isBeingReviewed && !canReviewFiscalObligations">
              {{ props.item.mod_340 }}
            </div>
            <v-edit-dialog
              v-else
              :return-value.sync="props.item.mod_340"
              large
              lazy
              persistent
              @save="saveRow(props.item)"
              @cancel="cancelSaveRow()"
            >
              <div>{{ props.item.mod_340 }}</div>
              <template v-slot:input>
                <div class="mt-3">Modelo 340</div>
                <v-select
                  color="primary"
                  v-model="props.item.mod_340"
                  item-text="text"
                  item-value="value"
                  :items="modelOptions"
                  row
                ></v-select>
              </template>
            </v-edit-dialog>
          </td>
          <td
            class="text-xs-center"
            v-if="
              quarter !== '202' &&
                (filters.columns.includes('all') || filters.columns.includes('mod_347'))
            "
            :bgcolor="getBgColorForModelEntries(props.item.mod_347)"
          >
            <div v-if="isBeingReviewed && !canReviewFiscalObligations">
              {{ props.item.mod_347 }}
            </div>
            <v-edit-dialog
              v-else
              :return-value.sync="props.item.mod_347"
              large
              lazy
              persistent
              @save="saveRow(props.item)"
              @cancel="cancelSaveRow()"
            >
              <div>{{ props.item.mod_347 }}</div>
              <template v-slot:input>
                <div class="mt-3">Modelo 347</div>
                <v-select
                  color="primary"
                  v-model="props.item.mod_347"
                  item-text="text"
                  item-value="value"
                  :items="modelOptions"
                  row
                ></v-select>
              </template>
            </v-edit-dialog>
          </td>
          <td
            class="text-xs-center"
            v-if="
              quarter !== '202' &&
                (filters.columns.includes('all') || filters.columns.includes('mod_349'))
            "
            :bgcolor="getBgColorForModelEntries(props.item.mod_349)"
          >
            <div v-if="isBeingReviewed && !canReviewFiscalObligations">
              {{ props.item.mod_349 }}
            </div>
            <v-edit-dialog
              v-else
              :return-value.sync="props.item.mod_349"
              large
              lazy
              persistent
              @save="saveRow(props.item)"
              @cancel="cancelSaveRow()"
            >
              <div>{{ props.item.mod_349 }}</div>
              <template v-slot:input>
                <div class="mt-3">Modelo 349</div>
                <v-select
                  color="primary"
                  v-model="props.item.mod_349"
                  item-text="text"
                  item-value="value"
                  :items="modelOptions"
                  row
                ></v-select>
              </template>
            </v-edit-dialog>
          </td>
          <td
            class="text-xs-center"
            v-if="
              quarter !== '202' &&
                (filters.columns.includes('all') || filters.columns.includes('mod_369'))
            "
            :bgcolor="getBgColorForModelEntries(props.item.mod_369)"
          >
            <div v-if="isBeingReviewed && !canReviewFiscalObligations">
              {{ props.item.mod_369 }}
            </div>
            <v-edit-dialog
              v-else
              :return-value.sync="props.item.mod_369"
              large
              lazy
              persistent
              @save="saveRow(props.item)"
              @cancel="cancelSaveRow()"
            >
              <div>{{ props.item.mod_369 }}</div>
              <template v-slot:input>
                <div class="mt-3">Modelo 369</div>
                <v-select
                  color="primary"
                  v-model="props.item.mod_369"
                  item-text="text"
                  item-value="value"
                  :items="modelOptions"
                  row
                ></v-select>
              </template>
            </v-edit-dialog>
          </td>
          <td
            class="text-xs-center"
            v-if="
              quarter !== '202' &&
                (filters.columns.includes('all') || filters.columns.includes('mod_370'))
            "
            :bgcolor="getBgColorForModelEntries(props.item.mod_370)"
          >
            <div v-if="isBeingReviewed && !canReviewFiscalObligations">
              {{ props.item.mod_370 }}
            </div>
            <v-edit-dialog
              v-else
              :return-value.sync="props.item.mod_370"
              large
              lazy
              persistent
              @save="saveRow(props.item)"
              @cancel="cancelSaveRow()"
            >
              <div>{{ props.item.mod_370 }}</div>
              <template v-slot:input>
                <div class="mt-3">Modelo 370</div>
                <v-select
                  color="primary"
                  v-model="props.item.mod_370"
                  item-text="text"
                  item-value="value"
                  :items="modelOptions"
                  row
                ></v-select>
              </template>
            </v-edit-dialog>
          </td>
          <td
            class="text-xs-center"
            v-if="
              quarter !== '202' &&
                (filters.columns.includes('all') || filters.columns.includes('mod_390'))
            "
            :bgcolor="getBgColorForModelEntries(props.item.mod_390)"
          >
            <div v-if="isBeingReviewed && !canReviewFiscalObligations">
              {{ props.item.mod_390 }}
            </div>
            <v-edit-dialog
              v-else
              :return-value.sync="props.item.mod_390"
              large
              lazy
              persistent
              @save="saveRow(props.item)"
              @cancel="cancelSaveRow()"
            >
              <div>{{ props.item.mod_390 }}</div>
              <template v-slot:input>
                <div class="mt-3">Modelo 390</div>
                <v-select
                  color="primary"
                  v-model="props.item.mod_390"
                  item-text="text"
                  item-value="value"
                  :items="modelOptions"
                  row
                ></v-select>
              </template>
            </v-edit-dialog>
          </td>
          <td
            class="text-xs-center"
            v-if="
              quarter !== '202' &&
                (filters.columns.includes('all') || filters.columns.includes('mod_392'))
            "
            :bgcolor="getBgColorForModelEntries(props.item.mod_392)"
          >
            <div v-if="isBeingReviewed && !canReviewFiscalObligations">
              {{ props.item.mod_392 }}
            </div>
            <v-edit-dialog
              v-else
              :return-value.sync="props.item.mod_392"
              large
              lazy
              persistent
              @save="saveRow(props.item)"
              @cancel="cancelSaveRow()"
            >
              <div>{{ props.item.mod_392 }}</div>
              <template v-slot:input>
                <div class="mt-3">Modelo 392</div>
                <v-select
                  color="primary"
                  v-model="props.item.mod_392"
                  item-text="text"
                  item-value="value"
                  :items="modelOptions"
                  row
                ></v-select>
              </template>
            </v-edit-dialog>
          </td>
          <td
            class="text-xs-center"
            v-if="
              quarter !== '202' &&
                (filters.columns.includes('all') || filters.columns.includes('mod_412'))
            "
            :bgcolor="getBgColorForModelEntries(props.item.mod_412)"
          >
            <div v-if="isBeingReviewed && !canReviewFiscalObligations">
              {{ props.item.mod_412 }}
            </div>
            <v-edit-dialog
              v-else
              :return-value.sync="props.item.mod_412"
              large
              lazy
              persistent
              @save="saveRow(props.item)"
              @cancel="cancelSaveRow()"
            >
              <div>{{ props.item.mod_412 }}</div>
              <template v-slot:input>
                <div class="mt-3">Modelo 412</div>
                <v-select
                  color="primary"
                  v-model="props.item.mod_412"
                  item-text="text"
                  item-value="value"
                  :items="modelOptions"
                  row
                ></v-select>
              </template>
            </v-edit-dialog>
          </td>
          <td
            class="text-xs-center"
            v-if="
              quarter !== '202' &&
                (filters.columns.includes('all') || filters.columns.includes('mod_415'))
            "
            :bgcolor="getBgColorForModelEntries(props.item.mod_415)"
          >
            <div v-if="isBeingReviewed && !canReviewFiscalObligations">
              {{ props.item.mod_415 }}
            </div>
            <v-edit-dialog
              v-else
              :return-value.sync="props.item.mod_415"
              large
              lazy
              persistent
              @save="saveRow(props.item)"
              @cancel="cancelSaveRow()"
            >
              <div>{{ props.item.mod_415 }}</div>
              <template v-slot:input>
                <div class="mt-3">Modelo 415</div>
                <v-select
                  color="primary"
                  v-model="props.item.mod_415"
                  item-text="text"
                  item-value="value"
                  :items="modelOptions"
                  row
                ></v-select>
              </template>
            </v-edit-dialog>
          </td>
          <td
            class="text-xs-center"
            v-if="
              quarter !== '202' &&
                (filters.columns.includes('all') || filters.columns.includes('mod_417'))
            "
            :bgcolor="getBgColorForModelEntries(props.item.mod_417)"
          >
            <div v-if="isBeingReviewed && !canReviewFiscalObligations">
              {{ props.item.mod_417 }}
            </div>
            <v-edit-dialog
              v-else
              :return-value.sync="props.item.mod_417"
              large
              lazy
              persistent
              @save="saveRow(props.item)"
              @cancel="cancelSaveRow()"
            >
              <div>{{ props.item.mod_417 }}</div>
              <template v-slot:input>
                <div class="mt-3">Modelo 417</div>
                <v-select
                  color="primary"
                  v-model="props.item.mod_417"
                  item-text="text"
                  item-value="value"
                  :items="modelOptions"
                  row
                ></v-select>
              </template>
            </v-edit-dialog>
          </td>
          <td
            class="text-xs-center"
            v-if="
              quarter !== '202' &&
                (filters.columns.includes('all') || filters.columns.includes('mod_420'))
            "
            :bgcolor="getBgColorForModelEntries(props.item.mod_420)"
          >
            <div v-if="isBeingReviewed && !canReviewFiscalObligations">
              {{ props.item.mod_420 }}
            </div>
            <v-edit-dialog
              v-else
              :return-value.sync="props.item.mod_420"
              large
              lazy
              persistent
              @save="saveRow(props.item)"
              @cancel="cancelSaveRow()"
            >
              <div>{{ props.item.mod_420 }}</div>
              <template v-slot:input>
                <div class="mt-3">Modelo 420</div>
                <v-select
                  color="primary"
                  v-model="props.item.mod_420"
                  item-text="text"
                  item-value="value"
                  :items="modelOptions"
                  row
                ></v-select>
              </template>
            </v-edit-dialog>
          </td>
          <td
            class="text-xs-center"
            v-if="
              quarter !== '202' &&
                (filters.columns.includes('all') || filters.columns.includes('mod_421'))
            "
            :bgcolor="getBgColorForModelEntries(props.item.mod_421)"
          >
            <div v-if="isBeingReviewed && !canReviewFiscalObligations">
              {{ props.item.mod_421 }}
            </div>
            <v-edit-dialog
              v-else
              :return-value.sync="props.item.mod_421"
              large
              lazy
              persistent
              @save="saveRow(props.item)"
              @cancel="cancelSaveRow()"
            >
              <div>{{ props.item.mod_421 }}</div>
              <template v-slot:input>
                <div class="mt-3">Modelo 421</div>
                <v-select
                  color="primary"
                  v-model="props.item.mod_421"
                  item-text="text"
                  item-value="value"
                  :items="modelOptions"
                  row
                ></v-select>
              </template>
            </v-edit-dialog>
          </td>
          <td
            class="text-xs-center"
            v-if="
              quarter !== '202' &&
                (filters.columns.includes('all') || filters.columns.includes('mod_425'))
            "
            :bgcolor="getBgColorForModelEntries(props.item.mod_425)"
          >
            <div v-if="isBeingReviewed && !canReviewFiscalObligations">
              {{ props.item.mod_425 }}
            </div>
            <v-edit-dialog
              v-else
              :return-value.sync="props.item.mod_425"
              large
              lazy
              persistent
              @save="saveRow(props.item)"
              @cancel="cancelSaveRow()"
            >
              <div>{{ props.item.mod_425 }}</div>
              <template v-slot:input>
                <div class="mt-3">Modelo 425</div>
                <v-select
                  color="primary"
                  v-model="props.item.mod_425"
                  item-text="text"
                  item-value="value"
                  :items="modelOptions"
                  row
                ></v-select>
              </template>
            </v-edit-dialog>
          </td>
          <td
            class="text-xs-center"
            v-if="
              quarter !== '202' &&
                (filters.columns.includes('all') || filters.columns.includes('mod_592'))
            "
            :bgcolor="getBgColorForModelEntries(props.item.mod_592)"
          >
            <div v-if="isBeingReviewed && !canReviewFiscalObligations">
              {{ props.item.mod_592 }}
            </div>
            <v-edit-dialog
              v-else
              :return-value.sync="props.item.mod_592"
              large
              lazy
              persistent
              @save="saveRow(props.item)"
              @cancel="cancelSaveRow()"
            >
              <div>{{ props.item.mod_592 }}</div>
              <template v-slot:input>
                <div class="mt-3">Modelo 592</div>
                <v-select
                  color="primary"
                  v-model="props.item.mod_592"
                  item-text="text"
                  item-value="value"
                  :items="modelOptions"
                  row
                ></v-select>
              </template>
            </v-edit-dialog>
          </td>
        </tr>
      </template>
    </v-data-table>
    <manage-of-111-190-table
      ref="manageModel111Table"
      v-if="showManageModel111"
      :show_manage_model_111="showManageModel111"
      :year="selectedYear"
      :consultant_ids="selectedConsultants"
      :labor_consultant_ids="manage111Filters.labor_consultant_ids"
      :search="filters.search"
      :consultants-list="consultantsList"
      :selected_model_type="manage111Filters.selectedModelType"
      :selected_model_status="manage111Filters.selectedModelStatus"
      :has_employees="manage111Filters.has_employees"
      :has_professionals="manage111Filters.has_professionals"
      :is-being-reviewed="isBeingReviewed"
      :can-review-fiscal-obligations="canReviewFiscalObligations"
    ></manage-of-111-190-table>
    <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
      {{ snackText }}
    </v-snackbar>
  </v-card>
</template>

<script>
import apiCtrl from '@/services/api/abstract/abstract-api.js';
import EmpresaAPI from '../../aplifisa/services/fiscal';
import ConsultantAPI from '../../customers-and-consultants/services/consultantAPI';
import ManageFiscalObligation111and190Table from '@/modules/admin/fiscal-obligations/components/ManageFiscalObligation111and190Table';
export default {
  name: 'ManageFiscalObligationsTable',
  components: {
    'manage-of-111-190-table': ManageFiscalObligation111and190Table,
  },
  props: ['ownConsultant', 'canReviewFiscalObligations'],
  data() {
    return {
      selectedItems: [],
      selectAllRows: false,
      loading: false,
      exportingExcel: false,
      creatingFiscalObligations: false,
      cloningFiscalObligations: false,
      bulkSavingFiscalObligations: false,
      showCreateFiscalObligationForm: false,
      showDeleteFiscalObligationForm: false,
      showCloneQuarterForm: false,
      showBulkEditForm: false,
      headers: [],
      fiscalObligations: [],
      exportFiscalObligationsList: [],
      year: null,
      nextYear: null,
      years: [],
      quarter: null,
      showManageModel111: false,
      companiesList: [],
      consultantsList: [],
      form: {
        allCompanies: false,
        companies: [],
        year: null,
        quarter: null,
        consultant_id: null,
        tax_regime: null,
        agency: null,
        prorate: null,
        observations: null,
        showValidationErrors: false,
      },
      modelOptions: [
        { text: 'SIN OBLIGACIÓN', value: null },
        { text: 'PENDIENTE', value: 'PENDIENTE' },
        { text: 'DOMICILIAR?', value: 'DOMICILIAR?' },
        { text: 'NRC?', value: 'NRC?' },
        { text: 'DOMICILIAR', value: 'DOMICILIAR' },
        { text: 'NRC', value: 'NRC' },
        { text: 'APLAZAR', value: 'APLAZAR' },
        { text: 'COMPENSAR', value: 'COMPENSAR' },
        { text: 'NEGATIVO', value: 'NEGATIVO' },
        { text: 'PRESENTAR', value: 'PRESENTAR' },
        { text: 'NO TIENE', value: 'NO TIENE' },
        { text: 'PRESENTADO', value: 'PRESENTADO' },
        { text: 'PRESENTADO APLAZADO', value: 'PRESENTADO APLAZADO' },
        { text: 'A DEVOLVER', value: 'A DEVOLVER' },
        { text: 'EN BLANCO', value: 'EN BLANCO' },
      ],
      snack: false,
      snackText: '',
      snackColor: 'info',
      fObligationsPagination: {
        descending: true,
        page: 1,
        rowsPerPage: 10, // -1 for All",
        sortBy: '',
        totalItems: 0,
      },
      sortTable: false,
      filters: {
        name: '',
        consultant_ids: [],
        tax_regime: '',
        agency: '',
        observations: '',
        search: '',
        selectedModelType: '',
        selectedModelStatus: '',
        columns: ['all'],
        previousColumns: [],
        fiscalStatus: '',
      },
      manage111Filters: {
        labor_consultant_ids: [],
        has_employees: null,
        has_professionals: null,
        selectedModelType: '',
        selectedModelStatus: '',
      },
      clone: {
        showValidationErrors: false,
        originYear: null,
        originQuarter: null,
        destinyYear: null,
        destinyQuarter: null,
      },
      bulk: {
        fieldText: null,
        fieldValue: null,
        modelStatus: null,
        consultant: null,
        text: null,
        active: null,
        status: null,
        taxRegime: null,
        agency: null,
      },
      fiscalStatusOptions: [
        { text: 'CONTABILIZADO', value: 'CONTABILIZADO' },
        { text: 'ENVIADO', value: 'ENVIADO' },
        { text: 'CERRADO', value: 'CERRADO' },
        { text: 'SIN DATOS', value: 'SIN_DATOS' },
      ],
      taxRegimeOptions: [
        { text: 'IMP. SOCIEDADES', value: 'IMP. SOCIEDADES' },
        { text: 'E.D. SIMPLIFICADA', value: 'E.D. SIMPLIFICADA' },
        { text: 'E.D.S. (REPEP)', value: 'E.D.S. (REPEP)' },
        { text: 'E.D. OBJETIVA', value: 'E.D. OBJETIVA' },
        { text: 'E.D. NORMAL', value: 'E.D. NORMAL' },
      ],
      agencyOptions: [
        { text: 'ESTATAL', value: 'ESTATAL' },
        { text: 'CANARIAS', value: 'CANARIAS' },
        { text: 'F. VIZCAYA', value: 'F. VIZCAYA' },
        { text: 'F. NAVARRA', value: 'F. NAVARRA' },
        { text: 'F. GUIPUZCUA', value: 'F. GUIPUZCUA' },
        { text: 'F. ÁLAVA', value: 'F. ÁLAVA' },
      ],
      currentReview: null,
      startingReview: false,
      finishingReview: false,
    };
  },
  beforeMount() {
    // Calculate the quarter and year to avoid changing all time when it is time to generate it
    const today = new Date();
    const year = today.getFullYear();
    const nextYear = year + 1;

    const month = today.getMonth();
    const quarter = Math.floor(month / 3 + 1);

    this.year = year;
    this.nextYear = nextYear;
    this.quarter = quarter.toString();

    // Show T4 and previous year in January
    if (quarter === 1 && month === 0) {
      this.quarter = '4';
      this.year = year - 1;
    }

    // Show T1 in April
    if (quarter === 2 && month === 3) {
      this.quarter = '1';
    }

    // Show T2 in July
    if (quarter === 3 && month === 6) {
      this.quarter = '2';
    }

    // Show T3 in October
    if (quarter === 4 && month === 9) {
      this.quarter = '3';
    }

    this.getCurrentFiscalObligationReview();
  },
  mounted() {
    if (this.ownConsultant) {
      this.filters.consultant_ids.push(this.ownConsultant);
    }
    this.manage111Filters.labor_consultant_ids = [];
    this.getYears();
    this.getConsultantsList();
    this.getFiscalObligationList();
    this.getCompaniesList();
    if (localStorage.getItem('fo_filters_columns')) {
      const columns = JSON.parse(localStorage.getItem('fo_filters_columns'));
      if (columns.length > 0) {
        this.filters.columns = columns;
      }
    }
  },
  computed: {
    currentPage() {
      return this.fObligationsPagination.page;
    },
    perPage() {
      return this.fObligationsPagination.rowsPerPage;
    },
    sortBy() {
      return this.fObligationsPagination.sortBy;
    },
    descending() {
      return this.fObligationsPagination.descending;
    },
    selectedConsultants() {
      return this.filters.consultant_ids;
    },
    search() {
      return this.filters.search;
    },
    modelTypes() {
      return this.headers.filter(header => header.value.includes('mod_'));
    },
    selectedModelType() {
      return this.filters.selectedModelType;
    },
    selectedModelStatus() {
      return this.filters.selectedModelStatus;
    },
    selectedYear() {
      return this.year;
    },
    selectedQuarter() {
      return this.quarter;
    },
    filterColumnsList() {
      const all = [{ text: 'TODAS', value: 'all' }];
      return all.concat(this.headers);
    },
    selectedColumns() {
      return this.filters.columns;
    },
    selectedFiscalStatus() {
      return this.filters.fiscalStatus;
    },
    isBeingReviewed() {
      return !!(this.currentReview && this.currentReview['finish_date'] == null);
    },
  },
  methods: {
    selectAllTableRows() {
      if (
        this.selectedItems.length === 0 ||
        (this.selectedItems.length >= 1 &&
          this.selectedItems.length < this.fiscalObligations.length)
      ) {
        let selected = [];
        this.fiscalObligations.forEach(item => {
          selected.push(item);
        });
        this.selectedItems = selected;
      } else if (this.selectedItems.length === this.fiscalObligations.length) {
        this.selectedItems = [];
      }
    },
    showSnackMessage(action, message) {
      this.snackColor = action;
      this.snackText = message;
      this.snack = true;
    },
    updateConsultantRow(item) {
      let consultant = this.consultantsList.find(
        consultant => consultant.value === item.consultant_id,
      );
      if (consultant) {
        item.consultant = consultant.text;
      }
    },
    updateStatusRow(item) {
      item.active ? (item.active_text = 'ACTIVO') : (item.active_text = 'BAJA');
    },
    getYears() {
      let currentYear = new Date().getFullYear();
      let years = [];
      for (let i = 10; i >= 0; i--) {
        years.push({ text: currentYear - i, value: currentYear - i });
      }
      this.years = years.sort((a, b) => b.value - a.value);
    },
    getCompaniesList() {
      EmpresaAPI.getFiscalDataInputSelect().then(response => {
        this.companiesList = response.data;
      });
    },
    getConsultantsList() {
      ConsultantAPI.getConsultantInputSelect().then(response => {
        this.consultantsList = response.data.filter(item => item.inactive === null);
      });
    },
    resetForm() {
      this.form.showValidationErrors = false;
      this.form.year = null;
      this.form.quarter = null;
      this.form.companies = [];
      this.form.allCompanies = false;
      this.form.consultant_id = null;
      this.form.tax_regime = null;
      this.form.agency = null;
      this.form.observations = null;
      this.form.prorate = null;
      this.form.agency = null;
    },
    openCreateFiscalObligationDialog() {
      this.resetForm();
      this.showCreateFiscalObligationForm = true;
    },
    createFiscalObligations() {
      if (
        !this.form.year ||
        !this.form.quarter ||
        !this.form.agency ||
        !this.form.consultant_id ||
        !this.form.tax_regime ||
        (!this.form.allCompanies && !this.form.companies.length >= 1)
      ) {
        this.form.showValidationErrors = true;
      } else {
        this.creatingFiscalObligations = true;
        apiCtrl
          .post('/admin/fiscal-obligations/create', this.form)
          .then(res => {
            console.log(res);
            this.creatingFiscalObligations = false;
            this.showCreateFiscalObligationForm = false;
            this.getFiscalObligationList();
          })
          .catch(() => (this.creatingFiscalObligations = false));
      }
    },
    startFiscalObligationReview() {
      this.startingReview = true;
      apiCtrl
        .post('/admin/fiscal-obligations/start-review', {})
        .then(res => {
          this.startingReview = false;
          this.currentReview = res.data['data'];
        })
        .catch(() => {
          this.startingReview = false;
        });
    },
    finishFiscalObligationReview() {
      this.finishingReview = true;
      apiCtrl
        .post('/admin/fiscal-obligations/finish-review', {})
        .then(res => {
          this.finishingReview = false;
          this.currentReview = res.data['data'];
        })
        .catch(() => {
          this.finishingReview = false;
        });
    },
    getCurrentFiscalObligationReview() {
      // const config = {
      //   params: {
      //     active: true,
      //   },
      // };
      apiCtrl
        .get('/admin/fiscal-obligations/current-review', {})
        .then(res => {
          this.currentReview = res.data['data'];
        })
        .catch(() => {});
    },
    getFiscalObligationList() {
      if (!this.showManageModel111) {
        this.loading = true;
        const config = {
          params: {
            year: this.year,
            quarter: this.quarter,
            page: this.fObligationsPagination.page,
            per_page: this.fObligationsPagination.rowsPerPage,
            sort_by: this.fObligationsPagination.sortBy,
            descending: this.fObligationsPagination.descending,
            consultant_ids: this.filters.consultant_ids,
            search: this.filters.search,
            modelType: this.filters.selectedModelType,
            modelStatus: this.filters.selectedModelStatus,
            status: this.filters.fiscalStatus,
          },
        };
        apiCtrl
          .get('/admin/fiscal-obligations/list', config)
          .then(res => {
            console.log(res.data);
            this.fiscalObligations = res.data.data;
            this.headers = res.data.dataTable.headers;
            this.fObligationsPagination = {
              descending: this.fObligationsPagination.descending,
              page: this.fObligationsPagination.page,
              rowsPerPage: Number(res.data.meta.per_page), // -1 for All",
              sortBy: this.fObligationsPagination.sortBy,
              totalItems: Number(res.data.meta.total),
            };
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
            // this.showSnackMessage(
            //   'error',
            //   'Se ha producido un error al cargar las obligaciones fiscales',
            // );
          });
      }
    },
    deleteFiscalObligations() {
      this.showDeleteFiscalObligationForm = false;
      this.loading = true;
      let items = this.selectedItems.map(item => {
        return item.id;
      });
      apiCtrl
        .post('/admin/fiscal-obligations/delete', { fiscalObligations: items })
        .then(() => {
          this.selectedItems = [];
          this.selectAllRows = false;
          this.getFiscalObligationList();
        })
        .catch(() => {
          this.loading = false;
        });
    },
    saveRow(item) {
      // Update manually the name of consultant of the updated row in case it had changed
      this.updateConsultantRow(item);

      // Update manually the name of status of the updated row in case it had changed
      this.updateStatusRow(item);

      // Update the row entity in backend
      item.status = item.status === 'SIN_DATOS' ? null : item.status;
      apiCtrl
        .post('/admin/fiscal-obligations/update', item)
        .then(res => {
          console.log(res.data);
        })
        .catch(() => {
          // this.showSnackMessage('error', 'Se ha producido un error al actualizar');
          this.getFiscalObligationList();
        });
    },
    cancelSaveRow() {},
    getBgColorForModelEntries(status) {
      let color;
      switch (status) {
        case 'PENDIENTE':
          color = '#00afa8';
          break;
        case 'DOMICILIAR?':
          color = 'lemonchiffon';
          break;
        case 'NRC?':
          color = 'lemonchiffon';
          break;
        case 'DOMICILIAR':
          color = 'lightsalmon';
          break;
        case 'NRC':
          color = 'lightsalmon';
          break;
        case 'APLAZAR':
          color = 'lightsalmon';
          break;
        case 'COMPENSAR':
          color = 'lightblue';
          break;
        case 'NEGATIVO':
          color = 'lightblue';
          break;
        case 'PRESENTAR':
          color = 'lemonchiffon';
          break;
        case 'NO TIENE':
          color = 'lightgreen';
          break;
        case 'PRESENTADO':
          color = 'lightgreen';
          break;
        case 'PRESENTADO APLAZADO':
          color = 'lightpink';
          break;
        case 'A DEVOLVER':
          color = 'lightgreen';
          break;
        case 'EN BLANCO':
          color = 'white';
          break;
        default:
          color = 'lightgray';
      }
      return color;
    },
    getFiscalObligationsIfStopChanges() {
      this.loading = true;
      const params = {
        page: this.fObligationsPagination.page,
        per_page: this.fObligationsPagination.rowsPerPage,
        search: this.filters.search,
      };

      setTimeout(() => {
        if (
          params.page === this.fObligationsPagination.page &&
          params.per_page === this.fObligationsPagination.rowsPerPage &&
          params.search === this.filters.search
        ) {
          this.getFiscalObligationList();
        }
      }, 300);
    },
    openCloneQuarterDialog() {
      this.clone.showValidationErrors = false;
      this.clone.originYear = this.selectedYear;
      this.clone.originQuarter = this.selectedQuarter;
      this.clone.destinyYear = null;
      this.clone.destinyQuarter = null;
      this.showCloneQuarterForm = true;
    },
    cloneFiscalObligations() {
      if (
        !this.clone.originYear ||
        !this.clone.originQuarter ||
        !this.clone.destinyYear ||
        !this.clone.destinyQuarter
      ) {
        this.clone.showValidationErrors = true;
      } else {
        this.cloningFiscalObligations = true;
        apiCtrl
          .post('/admin/fiscal-obligations/clone?XDEBUG_SESSION_START=12299', this.clone)
          .then(res => {
            console.log(res);
            this.cloningFiscalObligations = false;
            this.showCloneQuarterForm = false;
            this.year = this.clone.destinyYear;
            this.quarter = this.clone.destinyQuarter;
          })
          .catch(() => (this.cloningFiscalObligations = false));
      }
    },
    openBulkEditForm(text, value) {
      if (!this.isBeingReviewed || (this.isBeingReviewed && this.canReviewFiscalObligations)) {
        this.bulk.fieldValue = value;
        if (value.includes('mod_')) {
          this.bulk.fieldText = 'Modelo ' + text;
        } else {
          this.bulk.fieldText = text;
        }

        this.bulk.consultant = null;
        this.bulk.modelStatus = null;
        this.bulk.text = null;
        this.bulk.active = null;
        this.bulk.taxRegime = null;
        this.bulk.status = null;
        this.bulk.agency = null;

        if (value !== 'name' && value !== 'clavedat' && value !== 'cif') {
          this.showBulkEditForm = true;
        }
      }
    },
    saveBulkEditForm() {
      this.bulkSavingFiscalObligations = true;
      let items = this.selectedItems.map(item => {
        return item.id;
      });
      apiCtrl
        .post('/admin/fiscal-obligations/bulk-edit', {
          selectedItems: items,
          field: this.bulk.fieldValue,
          modelStatus: this.bulk.modelStatus,
          consultant: this.bulk.consultant,
          text: this.bulk.text,
          active: this.bulk.active,
          status: this.bulk.status,
          agency: this.bulk.agency,
          tax_regime: this.bulk.taxRegime,
        })
        .then(res => {
          console.log(res);
          this.bulkSavingFiscalObligations = false;
          this.showBulkEditForm = false;
          this.selectedItems = [];
          this.selectAllRows = false;
          this.getFiscalObligationList();
        })
        .catch(() => {
          this.bulkSavingFiscalObligations = false;
          this.showBulkEditForm = false;
        });
    },
    async exportToExcel() {
      this.exportingExcel = true;
      if (this.showManageModel111) {
        await this.$refs.manageModel111Table.exportToExcel();
        await new Promise(r => setTimeout(r, 5000)).then(() => (this.exportingExcel = false));
      } else {
        import('../../../../plugins/Export2Excel.js').then(async excel => {
          const filterColumns = this.filters.columns.includes('all')
            ? this.headers.map(header => header.value)
            : this.filters.columns;
          const exportHeaders = this.headers
            .filter(header => filterColumns.includes(header.value))
            .map(header => header.text);
          const config = {
            params: {
              year: this.year,
              quarter: this.quarter,
              sort_by: this.fObligationsPagination.sortBy,
              descending: this.fObligationsPagination.descending,
              consultant_ids: this.filters.consultant_ids,
              search: this.filters.search,
              modelType: this.filters.selectedModelType,
              modelStatus: this.filters.selectedModelStatus,
              page: 1,
              per_page: this.fObligationsPagination.totalItems,
              exportToExcel: true,
              status: this.filters.fiscalStatus,
            },
          };
          let fiscalObligationsListToExport = [];
          await apiCtrl
            .get('/admin/fiscal-obligations/list', config)
            .then(res => {
              console.log(res.data);
              fiscalObligationsListToExport = res.data.data;
            })
            .catch(() => {
              this.showSnackMessage(
                'error',
                'Se ha producido un error al exportar las obligaciones fiscales',
              );
              this.exportingExcel = false;
            });
          const exportList = this.formatJson(filterColumns, fiscalObligationsListToExport);
          excel.export_json_to_excel({
            header: exportHeaders,
            data: exportList,
            filename: `obligaciones_fiscales_${this.year}_${this.quarter}`,
            autoWidth: true,
            bookType: 'xlsx',
          });
          this.exportingExcel = false;
        });
      }
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          return v[j];
        }),
      );
    },
    changeSort(column) {
      if (this.fObligationsPagination.sortBy === column) {
        this.fObligationsPagination.descending = !this.fObligationsPagination.descending;
      } else {
        this.fObligationsPagination.sortBy = column;
        this.fObligationsPagination.descending = false;
      }
    },
  },
  watch: {
    selectedYear: function() {
      if (this.currentPage === 1) {
        this.getFiscalObligationsIfStopChanges();
      } else {
        this.fObligationsPagination.page = 1;
      }
    },
    search: function() {
      if (this.currentPage === 1) {
        this.getFiscalObligationsIfStopChanges();
      } else {
        this.fObligationsPagination.page = 1;
      }
    },
    selectedQuarter: function() {
      if (this.selectedQuarter != null) {
        this.showManageModel111 = false;
        this.fiscalObligations = [];
        if (this.currentPage === 1) {
          this.getFiscalObligationsIfStopChanges();
        } else {
          this.fObligationsPagination.page = 1;
        }
      }
    },
    showManageModel111: function() {
      if (this.showManageModel111 === true) {
        this.quarter = null;
      }
    },
    currentPage: function() {
      this.getFiscalObligationsIfStopChanges();
    },
    perPage: function() {
      if (this.currentPage === 1) {
        this.getFiscalObligationsIfStopChanges();
      } else {
        this.fObligationsPagination.page = 1;
      }
    },
    sortBy: function() {
      if (this.sortBy != null && this.sortTable) {
        this.getFiscalObligationList();
      } else {
        if (this.descending === null) {
          this.sortTable = false;
        }
      }
    },
    descending: function() {
      if (this.descending != null) {
        this.getFiscalObligationList();
        this.sortTable = true;
      } else {
        if (this.sortBy === null) {
          this.sortTable = false;
        }
      }
    },
    selectedConsultants: function() {
      if (this.currentPage === 1) {
        this.getFiscalObligationsIfStopChanges();
      } else {
        this.fObligationsPagination.page = 1;
      }
    },
    selectedModelType: function() {
      if (this.selectedModelType) {
        this.filters.previousColumns = [...this.filters.columns];
        if (this.filters.columns.find(column => column.includes('all'))) {
          this.filters.columns = [
            'name',
            'consultant',
            'tax_regime',
            'agency',
            'prorate',
            'status',
            'active',
            'observations',
          ];
        } else {
          this.filters.columns = this.filters.columns.filter(column => !column.includes('mod_'));
        }

        this.filters.columns.push(this.selectedModelType);
      } else {
        this.filters.columns = [...this.filters.previousColumns];
        this.filters.selectedModelStatus = '';
      }
      if (this.currentPage === 1) {
        this.getFiscalObligationsIfStopChanges();
      } else {
        this.fObligationsPagination.page = 1;
      }
    },
    selectedModelStatus: function() {
      if (this.currentPage === 1) {
        this.getFiscalObligationsIfStopChanges();
      } else {
        this.fObligationsPagination.page = 1;
      }
    },
    selectedFiscalStatus: function() {
      if (this.currentPage === 1) {
        this.getFiscalObligationsIfStopChanges();
      } else {
        this.fObligationsPagination.page = 1;
      }
    },
    selectedColumns: function() {
      const columns = JSON.stringify(this.selectedColumns);
      localStorage.setItem('fo_filters_columns', columns);
    },
  },
};
</script>

<style scoped>
.bg-lightgray {
  background-color: lightgray;
}
.bg-lightgreen {
  background-color: #00afa8;
}
.text-red {
  color: red;
}
</style>
